module.exports = __webpack_public_path__ + "static/img/lt.c3aeac0d.svg";